const formatOnlyNumbers = (value: string) => value.replace(/\D/g, '').trim();

export default formatOnlyNumbers;
